<template>
  <div v-loading="showFlag">
    <t-card>
      <div>
        <t-row>
          <t-col :span="12" class="col_common_center">
            <!-- 新規 -->
            <t-button
              round
              type="primary"
              class="button_common"
              ref="addBtn"
              @click="addClick(true)"
            >
              <i class="el-icon-plus"></i>
              {{ $t("resource.COMMON_CONSTANT.ADD") }}
            </t-button></t-col
          >
          <t-col :span="12" class="col_common_center">
            <!-- 削除 -->
            <t-button
              round
              type="danger"
              class="button_common"
              ref="delBtn"
              @click="deleteClickSelected()"
            >
              <i class="el-icon-delete"></i>
              {{ $t("resource.COMMON_CONSTANT.DELETE") }}
            </t-button></t-col
          >
        </t-row>
      </div>

      <!-- 製品クローズ選択テーブル -->
      <t-table
        ref="productQtyChangeData"
        :data="productQtyChangeData"
        class="table_common"
        header-cell-class-name="bg-default"
        highlight-current-row
        :height="detailHeight"
        @row-click="handleRowClick"
        @row-dblclick="handleRowDblClick"
        border
      >
        <t-table-column type="selection" min-width="55" align="center" />
        <!-- テーブルの列 -->
        <t-table-column
          v-for="(column, index) in columns"
          :key="index"
          :type="column.type"
          :prop="column.prop"
          :label="column.label"
          :min-width="column.width"
          :align="column.align"
          :header-align="column.headerAlign"
          :class-name="column.class"
          :show-overflow-tooltip="column.overflowTooltip"
        >
        </t-table-column>
      </t-table>
    </t-card>
  </div>
</template>
<script>
import { httpApi } from "@/api/api";
import { t } from "@/locales";
import { commonApi } from "@/services/common";

import { ShowProductQtyChangeDetailDialog } from "@/components/Dialog";
import { getDialogContentHeight } from "@/utils/comFunction";
import { STR_EMPTY } from "@/utils/const";
import { Message, Modal } from "@tellus/component";

export default {
  data() {
    return {
      //比較用明細情報
      cmpDetailResult: {},
      //読み込み回数
      numLoads: 1,
      //製品クローズ選択テーブル
      productQtyChangeData: [],

      //現在選択されているセル
      currentCell: null,

      //製品クローズ選択テーブルの列
      columns: [
        {
          prop: "aodQuoteChildNoStr",
          label: t("resource.ADD_ALL_ORDER_INFO.QUOTE_CHILD_NO"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
          align: "left",
        },

        {
          prop: "aobAcceptDate",
          label: t("resource.ADD_ALL_ORDER_INFO.ACCEPT_ORDER_DATE"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          align: "center",
        },

        {
          prop: "odDate",
          label: t("resource.ADD_ALL_ORDER_INFO.ORDER_DATE"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          align: "center",
        },

        {
          prop: "aodOrderStatus",
          label: t("resource.ADD_ALL_ORDER_INFO.ORDER_STATUS"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          align: "center",
        },
      ],

      //明細情報のheight
      detailHeight: getDialogContentHeight(window.innerHeight, 20, 20, 10),

      data: null,

      showFlag: false,
    };
  },
  props: {
    //見積No.
    aobQuoteNo: {
      Type: String,
      default: STR_EMPTY,
    },
  },

  created() {
    // 製品数変更基本情報の検索
    this.getProductQtyData(this.aobQuoteNo);

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  mounted() {},

  methods: {
    // 製品数変更基本情報の検索
    getProductQtyData(data) {
      this.showFlag = true;

      commonApi(httpApi.GetProductQtyBasicData, data)
        .then((res) => {
          this.productQtyChangeData = res;
          // データの読み込
          // this.dataProcess(res);
        })
        .catch((err) => {
          Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        20,
        20,
        10
      );
    },

    //行データのクリック処理
    handleRowClick(row) {
      this.currentCell = row;
    },

    //行データのダブルクリック処理
    handleRowDblClick(row) {
      this.currentCell = row;
      this.addClick(false);
    },

    // 「新規」ボタン
    addClick(data) {
      // フォーカス削除
      this.$refs.addBtn.$el.blur();

      ShowProductQtyChangeDetailDialog(
        {
          isAdd: data,
          aobQuoteNo: this.aobQuoteNo,
          RowData: this.currentCell,
        },
        t("resource.button.quote_qty_change_detail_scr"),
        (target) => {
          this.$emit("ok");
          // this.getProductQtyData(this.aobQuoteNo);
        }
      );
    },

    deleteClickSelected() {
      // フォーカス削除
      this.$refs.delBtn.$el.blur();

      let data = this.$refs.productQtyChangeData.selection;

      if (data.length == 0) {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        })
          .then(() => {
            // 用户点击确认
            resolve(true);
          })
          .catch((error) => {});

        return;
      }

      for (const element of data) {
        if (!element.aodOrderStatusBool) {
          this.showMessage(t("message.ACCEPT_ORDER.NOT_DELETE"));
          return;
        }

        if (!element.delFlg) {
          let message =
            "見積子番No.「" +
            element.aodQuoteChildNoStr +
            "」の" +
            t("message.COMMON.CLOSE_NG_CHECK");

          this.showMessage(message);
          return;
        }
      }

      Modal.showWarning("", t("message.COMMON_MESSAGE.DELETE_CONFIRM_MSG"), {
        $type: "prompt",
        confirmButtonText: t("resource.COMMON_CONSTANT.YES"),
        cancelButtonText: t("resource.COMMON_CONSTANT.NO"),
        showCancelButton: true,
      })
        .then(() => {
          // 開始するのを待ちます
          this.showFlag = true;

          // 削除情報;
          commonApi(httpApi.DelProductQtyData, data)
            .then((res) => {
              //削除成功
              Message.showSuccess(t("message.COMMON_MESSAGE.DELETE_SUCCESS"));

              // 削除が完了した後、手配でのデータ設定がなく、データの変更も行われません
              if (res === "0") {
                this.$emit("ok");
              }
            })
            .catch((err) => {
              if (err.data != null) {
                if (err.data.Messages[0].Message === "OTHER") {
                  this.showMessage(t("message.ACCEPT_ORDER.NOT_DELETE"));
                } else if (err.data.Messages[0].Message === "qtyError") {
                  this.showMessage(t("message.COMMON.CLOSE_NG_CHECK"));
                } else {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                }
              } else {
                Message.showError(t("message.COMMON_MESSAGE.DELETE_FAILURE"));
              }
            })
            .finally(() => {
              this.getProductQtyData(this.aobQuoteNo);
              this.showFlag = false;
            });
        })
        .catch();
    },

    showMessage(message) {
      Modal.showError("", message, {
        $type: "prompt",
        confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
      })
        .then(() => {
          // 用户点击确认
          resolve(true);
        })
        .catch((error) => {});
    },
  },
};
</script>
<style scoped>
.cell_input .el-input__inner {
  height: 25px !important;
  padding: 0 5px !important;
}
</style>

